import { cookies } from "next/headers"

const RECENTLY_VIEWED_COOKIE = "kuhlyk_recently_viewed"
const MAX_RECENTLY_VIEWED = 12

function safeParseRecipeIds(value: string | undefined): string[] {
  if (!value) {
    return []
  }

  try {
    const parsed = JSON.parse(value) as unknown

    if (!Array.isArray(parsed)) {
      return []
    }

    return parsed.filter((item): item is string => typeof item === "string")
  } catch {
    return []
  }
}

export async function getRecentlyViewedRecipeIds(): Promise<string[]> {
  const cookieStore = await cookies()
  const raw = cookieStore.get(RECENTLY_VIEWED_COOKIE)?.value

  return safeParseRecipeIds(raw)
}

export async function setRecentlyViewedRecipeIds(recipeIds: string[]) {
  const cookieStore = await cookies()

  cookieStore.set(RECENTLY_VIEWED_COOKIE, JSON.stringify(recipeIds.slice(0, MAX_RECENTLY_VIEWED)), {
    httpOnly: false,
    sameSite: "lax",
    secure: process.env.NODE_ENV === "production",
    path: "/",
    maxAge: 60 * 60 * 24 * 30,
  })
}

export function buildRecentlyViewedRecipeIds(
  currentIds: string[],
  recipeId: string
): string[] {
  const deduped = currentIds.filter((id) => id !== recipeId)
  return [recipeId, ...deduped].slice(0, MAX_RECENTLY_VIEWED)
}